module.exports = "/images/logoglobenew.png?726751abb416968c9a2e5bef098b10bf";